<nav class="sidebar-nav">
    <ul id="sidebarnav" class="ctgf-left-sidebar">        
        <!-- First level menu -->
        <li class="sidebar-item" 
           
            *ngFor="let sidebarnavItem of sidebarnavItems"
            [routerLinkActive]="sidebarnavItem?.Submenu?.length != 0 ? '' : 'active'">
            
            <a  class="sidebar-link waves-effect waves-dark" 
                [routerLink]="sidebarnavItem.Path"  
                [ngClass]="{'active' : isActiveParent(sidebarnavItem) }"               
                (click)="addExpandClass(sidebarnavItem.Title)">
                    <span style="margin-left: 10px;"></span>
                    <span class="hide-menu">{{sidebarnavItem?.Title}}</span>
            </a>
    
            <!-- Submenu -->
            <ul aria-expanded="false" 
                class="collapse first-level"  
                *ngIf="sidebarnavItem?.Submenu?.length > 0"
                [ngClass]="{'in' : showMenu === sidebarnavItem.Title || nestedActivateActive(sidebarnavItem) }">
                
                <li class="sidebar-item" *ngFor="let sidebarnavSubItem of sidebarnavItem.Submenu">
                    <a class="sidebar-link" 
                    [routerLink]="sidebarnavSubItem?.Submenu?.length > 0 ? null : [sidebarnavSubItem.Path]" 
                    [routerLinkActive]="sidebarnavSubItem?.Submenu?.length > 0 ? '' : 'active'"              
                    (click)="addActiveClass(sidebarnavSubItem.Title)">
                        <i *ngIf="sidebarnavSubItem.Icon != null" [ngClass]="[sidebarnavSubItem.Icon]"></i>
                        <span class="hide-menu">{{sidebarnavSubItem.Title}}</span>
                    </a>
                </li>
            </ul>
        </li>        
    </ul>
</nav>